<template>
  <form autocomplete="off"
        novalidate
        @submit.prevent="handleSubmit">
    <div>
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label for="local">Base para Busca</label>
            <div class="d-block">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  id="local"
                  v-model="searchType"
                  v-validate="'required'"
                  class="custom-control-input"
                  name="tipo_busca"
                  required
                  type="radio"
                  value="local">
                <label class="custom-control-label"
                       for="local">Local</label>
              </div>

              <div v-if="disponivel"
                   class="custom-control custom-radio custom-control-inline">
                <input
                  id="registro"
                  v-model="searchType"
                  v-validate="'required'"
                  class="custom-control-input"
                  name="tipo_busca"
                  required
                  type="radio"
                  value="crc">
                <label class="custom-control-label"
                       for="registro">CRC</label>
              </div>
            </div>
          </div>
        </div>

        <div v-if="searchType === 'crc'"
             class="col-9">
          <div class="row">
            <pesquisar-cartorio :prop-esconder-campos="{'cns': true }"
                                @updated="cartorioSelected" />
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="registerCPF">CPF</label>
        <input
          id="registerCPF"
          v-model="dataFilters.cpf"
          v-validate="'required'"
          v-mask="`999.999.999-99`"
          aria-label="Nome do registrado"
          class="form-control"
          name="registerCPF"
          placeholder="000.000.000-00"
          required
          type="text">
      </div>
      <div class="form-group">
        <label for="registerName">Nome do registrado</label>
        <input
          id="registerName"
          ref="registerName"
          v-model.lazy="dataFilters.nome"
          v-uppercase
          v-validate="'required'"
          aria-label="Nome do registrado"
          class="form-control"
          :class="{ 'boxConditions no-focus-style': dataFilters.tipoLivro !== null }"
          name="registerName"
          placeholder="Digite o nome para pesquisa"
          required
          type="text">
      </div>
      <div class="row">
        <!--  Radios buttons -->
        <div class="col-sm col-12 order-1 order-sm-0">
          <div class="row no-gutters justify-content-between align-items-center">
            <div
              v-for="item in typeList"
              :key="item.valor"
              class="radioBox d-inline-flex align-items-center"
              :class="{ 'active': tipoLivro === item.valor }"
              @click="tipoLivro = item.valor, $refs['registerName'].focus()">
              <label
                :key="item.id"
                class="radioBox_btn w-100 text-center position-relative mb-0"
                :for="item.text">
                <svg class="radioBox_icon icon--md"
                     role="presentation">
                  <use :xlink:href="'#' + item.icon.id" />
                </svg>
                <input
                  :id="item.text"
                  v-model="tipoLivro"
                  class="radioBox_input position-absolute"
                  name="typeFilter"
                  type="radio"
                  :value="item.valor"
                  @change="changeFilters">
                <span class="radioBox_title w-100 d-inline-block">{{ item.text }}</span>
              </label>
            </div>
          </div>
        </div>

        <!--  Principais -->
        <div class="col-sm col-12 mb-3 mb-sm-0">
          <div class="row">
            <div class="col col-sm-4">
              <label for="livro">Livro</label>
              <input
                id="livro"
                v-model="dataFilters.num_livro"
                v-validate="'min_value:1'"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': errors.has('livro') }"
                min="1"
                name="livro"
                placeholder="00000"
                type="number"
                @change="changeFilters">
              <small v-if="errors.has('livro')"
                     class="invalid-feedback">{{ errors.first('livro') }}</small>
            </div>

            <div class="col col-sm-4">
              <label for="folha">Folha</label>
              <input
                id="folha"
                v-model="dataFilters.num_folha"
                v-validate="'min_value:1'"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': errors.has('folha') }"
                min="1"
                name="folha"
                placeholder="000"
                type="number"
                @change="changeFilters">
              <small v-if="errors.has('folha')"
                     class="invalid-feedback">{{ errors.first('folha') }}</small>
            </div>

            <div class="col col-sm-4">
              <label for="registro">Termo <small class="text-muted">(Registro)</small></label>
              <input
                id="registro"
                v-model="dataFilters.termo"
                v-validate="'min_value:1'"
                class="form-control form-control-sm"
                :class="{ 'is-invalid': errors.has('registro') }"
                min="1"
                name="registro"
                placeholder="0000000"
                type="number"
                @change="changeFilters">
              <small
                v-if="errors.has('registro')"
                class="invalid-feedback">{{ errors.first('registro') }}</small>
            </div>

            <div class="custom-control custom-checkbox custom-control-inline  ml-3">
              <input
                id="flag_somente_rascunhos"
                v-model="dataFilters.flag_somente_rascunhos"
                class="custom-control-input"
                type="checkbox">

              <label class="custom-control-label"
                     for="flag_somente_rascunhos">Mostrar rascunhos na busca</label>
            </div>
          </div>
        </div>
      </div>

      <div v-if="tipoLivro"
           class="p-2 pm-0">
        <div v-if="tipoLivro === 'O'"
             class="row">
          <div class="col-1 mr-3">
            <label for="">Natimorto:</label>
          </div>
          <div class="col-1">
            <div class="custom-control custom-radio custom-control-inline">
              <input
                id="nao_natirmorto"
                v-model="dataFilters.natimorto"
                class="custom-control-input"
                name="nao_natirmorto"
                type="radio"
                :value="false">
              <label class="custom-control-label"
                     for="nao_natirmorto">Não</label>
            </div>
          </div>
          <div class="col-1">
            <div class="custom-control custom-radio custom-control-inline">
              <input
                id="sim_natimorto"
                v-model="dataFilters.natimorto"
                class="custom-control-input"
                name="sim_natimorto"
                type="radio"
                :value="true">
              <label class="custom-control-label"
                     for="sim_natimorto">Sim</label>
            </div>
          </div>
        </div>
        <div v-if="(tipoLivro === 'N') || (tipoLivro === 'O')"
             class="row">
          <div class="col-sm-6 col-12">
            <div class="form-group">
              <label for="genitorUm">Nome do 1º Genitor</label>
              <input
                id="genitorUm"
                v-model.lazy="dataFilters.nomeGenitor1"
                v-uppercase
                class="form-control form-control-sm"
                :class="{ 'is-invalid': errors.has('genitorUm') }"
                name="genitorUm"
                placeholder="Ex: José Dantas"
                type="text"
                @change="changeFilters">
              <small
                v-if="errors.has('genitorUm')"
                class="invalid-feedback">{{ errors.first('genitorUm') }}</small>
            </div>
          </div>

          <div class="col-sm-6 col-12">
            <div class="form-group">
              <label for="genitorDois">Nome do 2º Genitor</label>

              <input
                id="genitorDois"
                v-model.lazy="dataFilters.nomeGenitor2"
                v-uppercase
                class="form-control form-control-sm"
                :class="{ 'is-invalid': errors.has('genitorDois') }"
                name="genitorDois"
                placeholder="Ex: Maria Clara"
                type="text"
                @change="changeFilters">
              <small
                v-if="errors.has('genitorDois')"
                class="invalid-feedback">{{ errors.first('genitorDois') }}</small>
            </div>
          </div>
        </div>
        <div v-if="(tipoLivro === 'C')"
             class="form-group">
          <div class="d-flex justify-content-between row">
            <label for="habilitacao"
                   class="col-1 mr-1">Mostrar:</label>

            <b-form-radio id="habilitacaoCasamento"
                          v-model="tipoRegistroCasamento"
                          class="col-2 ml-2"
                          value="D"
                          name="habilitacaoCasamento">
              Habilitação
            </b-form-radio>
            <b-form-radio id="registroCasamento"
                          v-model="tipoRegistroCasamento"
                          class="col"
                          value="C"
                          name="tipoRegistroCasamento">
              Registro
            </b-form-radio>
          </div>

          <div class="d-flex justify-content-between row">
            <label for="conjuge"
                   class="col-8">Nome do Cônjuge</label>
          </div>

          <input
            id="conjuge"
            v-model.lazy="dataFilters.nomeConjuge"
            v-uppercase
            class="form-control form-control-sm"
            :class="{ 'is-invalid': errors.has('conjuge') }"
            name="conjuge"
            placeholder="Ex: José Dantas"
            type="text"
            @change="changeFilters">
          <small v-if="errors.has('conjuge')"
                 class="invalid-feedback">{{ errors.first('conjuge') }}</small>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group mt-2">
            <label for="dataRegistro">Data de registro entre:</label>

            <div class="row">
              <div class="col">
                <input
                  id="dataRegistro"
                  v-model="data_registro_inicio"
                  v-mask="'##/##/####'"
                  v-validate="`date_format:dd/MM/yyyy|max_date: ${new Date()}`"
                  class="form-control form-control-sm"
                  :class="{ 'is-invalid': errors.has('dataRegistro') }"
                  maxlength="10"
                  name="dataRegistro"
                  placeholder="00/00/0000"
                  type="text"
                  @change="changeFilters">
                <small
                  v-if="errors.has('dataRegistro')"
                  class="invalid-feedback">{{ errors.first('dataRegistro') }}</small>
              </div>

              <div class="col">
                <input
                  id="dataRegistroFim"
                  v-model="data_registro_fim"
                  v-mask="'##/##/####'"
                  v-validate="`date_format:dd/MM/yyyy|max_date: ${new Date()}`"
                  class="form-control form-control-sm"
                  :class="{ 'is-invalid': errors.has('dataRegistroFim') }"
                  maxlength="10"
                  name="dataRegistroFim"
                  placeholder="00/00/0000"
                  type="text"
                  @change="changeFilters">
                <small
                  v-if="errors.has('dataRegistroFim')"
                  class="invalid-feedback">{{ errors.first('dataRegistroFim') }}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="form-group mt-2">
            <label for="dataOcorrido">Data do ocorrido entre:</label>

            <div class="row">
              <div class="col">
                <input
                  id="dataOcorrido"
                  v-model="data_ocorrido_inicio"
                  v-mask="'##/##/####'"
                  v-validate="`date_format:dd/MM/yyyy|max_date: ${new Date()}`"
                  class="form-control form-control-sm"
                  :class="{ 'is-invalid': errors.has('dataOcorrido') }"
                  maxlength="10"
                  name="dataOcorrido"
                  placeholder="00/00/0000"
                  type="text"
                  @change="changeFilters">
                <small
                  v-if="errors.has('dataOcorrido')"
                  class="invalid-feedback">{{ errors.first('dataOcorrido') }}</small>
              </div>

              <div class="col">
                <input
                  id="dataOcorridoFim"
                  v-model="data_ocorrido_fim"
                  v-mask="'##/##/####'"
                  v-validate="`date_format:dd/MM/yyyy|max_date: ${new Date()}`"
                  class="form-control form-control-sm"
                  :class="{ 'is-invalid': errors.has('dataOcorridoFim') }"
                  maxlength="10"
                  name="dataOcorridoFim"
                  placeholder="00/00/0000"
                  type="text"
                  @change="changeFilters">
                <small
                  v-if="errors.has('dataOcorridoFim')"
                  class="invalid-feedback">{{ errors.first('dataOcorridoFim') }}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="form-group mt-3">
            <label for />
            <div class="row">
              <div class="col">
                <button v-ripple
                        class="btn btn-secondary btn-sm btn-search"
                        type="submit">
                  Pesquisar
                  <IconSvg icon="search"
                           class="icon--xxs icons--white mb-2 mt-1 ml-1" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>


<script>
  /* assets */
  import icon_casamento from "@/assets/icons/engagement.svg?sprite"
  import icon_nasc from "@/assets/icons/baby-buggy.svg?sprite"
  import icon_obito from "@/assets/icons/flower.svg?sprite"
  import IconSvg  from "@/components/IconSvg"

  /* filters */
  import { filterMaskedNumber } from '@/filters/filters'

  /* utils */
  import { brDateToDatabaseFormat } from "@/utils/conversors"
  import { transformSearchedRascunho } from '@/utils/itemRascunho'

  /* components */
  import PesquisarCartorio from "../PesquisarCartorio"

  /* libraries */
  import { mapGetters } from "vuex"

  /* services */
  import BuscaService from '@/services/BuscaService'
  import EnderecosService from "@/services/Enderecos"

  export default {
    name: "SearchFilters",
    components: {
      PesquisarCartorio,
      IconSvg,
    },
    props: {
      orderBy: {
        type: String,
        default: 'NOME'
      }
    },
    data ()
    {
      return {
        searchType: 'local',
        results: [],
        selectsOptions: {
          states: [],
          cities: [],
          notaries: []
        },
        tipoLivro: 'N',
        tipoRegistroCasamento: 'C',
        stateSelected: "",
        data_registro_inicio: "",
        data_registro_fim: "",
        data_ocorrido_inicio: "",
        data_ocorrido_fim: "",
        dataFilters: {
          nome: "",
          religioso: false,
          natimorto: false,
          nomeConjuge: "",
          tipo_livro: null,
          num_livro: null,
          num_folha: null,
          termo: null,
          nomeGenitor1: null,
          nomeGenitor2: null,
          data_registro_inicio: "",
          data_registro_fim: "",
          data_ocorrido_inicio: "",
          data_ocorrido_fim: "",
          flag_somente_rascunhos: false,
          crc_uf: "",
          crc_city: "",
          crc_notary: ""
        },
        disponivel: false,
        typeList: [
          {
            text: "Nascimento",
            id: 1,
            valor: "N",
            icon: icon_nasc
          },
          {
            text: "Casamento",
            id: 2,
            valor: "C",
            icon: icon_casamento
          },
          {
            text: "Óbito",
            id: 3,
            valor: "O",
            icon: icon_obito
          },
        // {
        //   text: "Livro-E",
        //   id: 4,
        //   valor: "L",
        //   icon: icon_livroe
        // }
        ]
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    watch: {
      orderBy: function () {
        this.handleSubmit('OrderBy')
      },
      'dataFilters.flag_somente_rascunhos' () {
        this.$emit('onClear')
      }
    },
    mounted () {
      this.selectsOptions.states = EnderecosService.getStates()
      this.selectsOptions.cities = EnderecosService.getCities()
      setTimeout(() => {
        if (this.$refs["registerName"]) {
          this.$refs["registerName"].focus()
        }
      }, 100)
    },
    methods: {

      async handleSubmit (type) {
        try {
          loader({text: 'Aguarde...', active: true})

          if (!this.tipoLivro) {
            objSwal.error.title = "Erro!"
            objSwal.error.text = "Selecione o Livro para efetuar a busca."

            NProgress.done()


            return Swal.fire(objSwal.error)
          }

          const mode = process.env.NODE_ENV

          if (mode !== 'development' && type !== 'OrderBy' && !this.dataFilters.cpf && !this.dataFilters.nome &&  !this.dataFilters.tipoLivro &&  !this.dataFilters.num_livro && !this.dataFilters.termo && (!this.data_registro_inicio || !this.data_registro_fim) && (!this.data_ocorrido_inicio || !this.data_ocorrido_fim)) {
            const camposObrigatorios = [ "CPF", "Nome do registrado", "Livro", "Data do registro", "Data do ocorrido"]
            const textList = `<ul>${camposObrigatorios.map(res => `<li>${res}</li>`
            )}</ul>`

            objSwal.error.title = "Preencha algum dos campos abaixo:"
            objSwal.error.html =  textList.replace(/\,/g,'')
            objSwal.error.text = ""

            NProgress.done()

            return Swal.fire(objSwal.error).then(() => {
              objSwal.error.title = ''
              objSwal.error.text = ''
              objSwal.error.html = ''
            })
          }

          let data = this.dataFilters
          data.page = 1

          data = this.prepareDataToSent(data)

          const params = {
            ...data,
            cartorio_id: this.$store.state.auth.cartorio_id,
            orderby: this.orderBy
          }

          let result = await this.search(params)

          this.results = result.data

          this.$emit('onSearch', result)
          this.$emit('SearchParams', this.dataFilters)
        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false})
        }

      },
      prepareDataToSent (data = {}) {
        let dateParamNames = ['data_registro_inicio', 'data_registro_fim', 'data_ocorrido_inicio', 'data_ocorrido_fim']

        for (const dateParamName of dateParamNames) {
          this.configDatesParam(dateParamName, data)
        }

        if (this.searchType == 'crc') {
          data.crc_uf = this.dataFilters.crc_uf
          data.crc_city = this.dataFilters.crc_city
          data.crc_notary = this.dataFilters.crc_notary
        }

        data.tipo_livro = this.tipoLivro

        if (this.tipoLivro === 'C') {
          let tipo = data.religioso ? 'CR' : this.tipoRegistroCasamento

          data.tipo_livro = tipo
          data.tipo_registro = tipo
        }

        if (this.tipoLivro === 'O' && !this.dataFilters.flag_somente_rascunhos) {
          let tipo = data.natimorto ? 'NT' : null

          data.tipo_livro = ['O', 'NT']
          data.tipo_registro = tipo
        }

        if (this.tipoLivro === 'O' && this.dataFilters.flag_somente_rascunhos) {
          data.tipo_livro = ['O', 'NT']
          data.tipo_registro = 'O'
        }

        if (this.tipoLivro === 'N') {
          data.tipo_livro = 'N'
          data.tipo_registro = 'N'
        }


        if (data.cpf) {
          data.cpf = filterMaskedNumber(data.cpf)
        }

        if (!data.perPage) {
          data.perPage = 10
        }

        return data
      },
      configDatesParam (dateParamName = null, data = {}) {
        if (!dateParamName) return data

        let date = ''

        if (this[dateParamName]) {

          date = brDateToDatabaseFormat(this[dateParamName])
        }

        data[dateParamName] = date

        return data
      },
      async search (params) {
        let result = { data: [] }

        if (this.dataFilters.flag_somente_rascunhos === true) {

          if (!params.orderby ) params.orderby = 'RECENTES'

          const { data } = await BuscaService.searchRascunhoREI(params)

          if (data.docs) {
            result.data = data.docs.map((item) => transformSearchedRascunho(item))
          }

          result.page = data.page
          result.total = data.total
          result.perPage = data.limit
          result.lastPage = data.pages

        } else {
          if (params.orderby == 'RECENTES') params.orderBy = null

          const { data } = await BuscaService.searchREI(params)
          result = data
        }

        return result
      },
      changeFilters () {
        this.dataFilters.religioso = false
        this.dataFilters.natimorto = false
        this.$emit("onPage", 1)
      },

      cartorioSelected (value) {
        //TODO: abaixo esta indo os objetos direto para o dataFilters, tem que verificar qual valor será pesquisado na api e colocar diretamenta
        this.dataFilters.crc_uf = value.estado.uf
        this.dataFilters.crc_city = value.cidade.nome
        this.dataFilters.crc_notary = value.cartorio
      }

    }
  }
</script>


<style lang="scss">
@import "../../../scss/_utilities/_exports";

.radioBox {
  border: pxToRem(1) solid $color-gray-light;
  max-width: pxToRem(100);
  min-height: pxToRem(80);
  transition: background-color 0.15s linear, border-color 0.15s linear;
  width: 33%;

  &_btn {
    cursor: pointer;
  }

  &_input {
    height: 0;
    opacity: 0;
    width: 0;
  }

  &_icon {
    fill: $color-gray-light;
  }

  &_title {
    color: $color-gray-light;
    font-size: pxToRem(14);
    font-weight: 500;
    transition: color 0.15s linear;
  }

  &.active,
  &:hover {
    background-color: $color-logo;
    border-color: $color-logo;

    .radioBox_icon {
      fill: $color-white;
    }

    .radioBox_title {
      color: $color-white;
    }
  }
}

.boxConditions {
  border: pxToRem(4) solid $color-logo;
}
.btn-search {
  fill: $color-logo;

  &:hover {
    fill: white;
  }

  &:active, :focus, .focus {
    --webkit-box-shadow: none !important;
    box-shadow: none !important;
    outline: 0 !important;
  }
}


.no-focus-style {
  outline: none !important;
}
.no-focus-style:focus {
  border-color: none !important;
  outline: 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 0.25rem solid #0a6cae;
}
</style>
